<!-- components/VcClosingPopup.vue BR#175 pop-up notification in VC regarding closing of VC entity - mbeng-->
<template>
  <div
    v-if="visible"
   class="popup-overlay"
  >
    <!-- Popup -->
    <div
      class="popup-content"
    >
      
      <div>
        <h2 style="font-weight:bold">{{ $t("popup-important-notice ") }}</h2><br>
        <p>{{ $t("your-current-icm-account-is") }}</p><br>
        <p>{{ $t("to-continue-trading-without") }}</p><br>
        <p> {{ $t("if-you-have-any-remaining-balance") }}</p>
        
      <button
        @click="$emit('close')"
        class="text-white font-bold bg-opacity-50 hover:bg-opacity-80 rounded-full p-2 z-10"
        style="background-color: #004A81;"
      >
      ok
      </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "VcClosingPopup",
    props: {
    visible: {
      type: Boolean,
      required: true
    },
  },
  emits: ["close"],
  data() {
    return {
    };
  },
  computed: {
     ...mapGetters(["get_profile", "get_user_data"]),
    userLanguage() {
    return this.get_profile?.profile?.language;
  }
  },

};
</script>
<style scoped>
/* Simple popup styles */
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
}

.popup-content {
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  width: 400px;
  text-align: center;
}
</style>
